import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type {
	ActionRendererKeyToPayload,
	ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';

import { HighlightDecisionField } from '../project-update-fields/additional-notes/HighlightDecisionField';
import { HighlightLearningField } from '../project-update-fields/additional-notes/HighlightLearningField';
import { HighlightRiskField } from '../project-update-fields/additional-notes/HighlightRiskField';
import { UpdateNoteField } from '../project-update-fields/additional-notes/UpdateNoteField';
import { SummaryField } from '../project-update-fields/summary';

type Payload = ActionRendererKeyToPayload[typeof ActionKeys.CreateProjectProgressUpdate];

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.200'),
	},
});

export type Props = {
	action: ActionWith<Payload>;
};

export const CardBody = ({ action }: Props): React.JSX.Element => {
	const { summary, updateNote, highlightLearning, highlightRisk, highlightDecision } =
		action.data || {};

	return (
		<Box xcss={styles.container} testId="project-status-update-action-renderer.ui.card-body">
			<SummaryField summary={summary} />
			<UpdateNoteField updateNote={updateNote} />
			<HighlightRiskField highlight={highlightRisk} />
			<HighlightDecisionField highlight={highlightDecision} />
			<HighlightLearningField highlight={highlightLearning} />
		</Box>
	);
};
